export default __webpack_public_path__ + "static/TylerB-a29e020249dd60eff93e3a623ddf31e9.png";